document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains("homepage")) {
    // Delegate quantity button clicks
    document.addEventListener("click", function (e) {
      if (e.target.classList.contains("plus") || e.target.classList.contains("minus")) {
        const cartForm = e.target.closest(".add-cart");
        if (!cartForm) return;

        const quantityInput = cartForm.querySelector(".product-quantity");
        if (!quantityInput) return;

        let currentValue = parseInt(quantityInput.value, 10) || 1;

        if (e.target.classList.contains("plus")) {
          quantityInput.value = currentValue + 1;
        } else if (e.target.classList.contains("minus") && currentValue > 1) {
          quantityInput.value = currentValue - 1;
        }
      }
    });

    // Delegate quantity input validation
    document.addEventListener("change", function (e) {
      if (e.target.classList.contains("product-quantity")) {
        if (parseInt(e.target.value) < 1 || isNaN(parseInt(e.target.value))) {
          e.target.value = 1;
        }
      }
    });
  }
});

$(document).ready(function () {
    $('.fade').slick({
      dots: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear'
      }); 

    // you May know
    $('.multiple-cards').slick({
        dots: true,
        arrows: true, 
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
          {
            breakpoint: 1024,
            settings: { slidesToShow: 3, slidesToScroll: 3 }
          },
          {
            breakpoint: 991,
            settings: { slidesToShow: 2, slidesToScroll: 1 }
          },
          {
            breakpoint: 768,
            settings: { slidesToShow: 1, slidesToScroll: 1 }
          },
          {
            breakpoint: 680,
            settings: { slidesToShow: 1, slidesToScroll: 1 }
          },
          {
            breakpoint: 480,
            settings: { slidesToShow: 1, slidesToScroll: 1 }
          }
        ]
      }); 
      
    // Banner-Slider
    $('.single-item').slick({
        arrows: false,
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
      });
});  
    
// Product Detail
$(document).ready(function () {
    if ($(".slider-single").length && $(".slider-nav").length) {
    $(".slider-single").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 300,
        useTransform: true,
        asNavFor: ".slider-nav",
    });

    $(".slider-nav").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        speed: 300,
        infinite: true,
        autoplaySpeed: 2000,
        asNavFor: ".slider-single",
        dots: true,
        focusOnSelect: true,
    });

    // Ensure the option is properly set
    $(".slider-single").slick("slickSetOption", "asNavFor", ".slider-nav", true);
    $(".slider-nav").slick("slickSetOption", "asNavFor", ".slider-single", true);
    }
});

// Card Equal Height
$(document).ready(function () {
  function setEqualHeight() {
  var maxHeight = 0;
  
  // Reset height to auto before recalculating
  $(".grid-item").css("min-height", "auto");
  
  // Find the maximum height
  $(".grid-item").each(function () {
    var thisHeight = $(this).outerHeight();
    if (thisHeight > maxHeight) {
      maxHeight = thisHeight;
    }
  });
  
  // Apply the max height as min-height to allow natural expansion
  $(".grid-item").css("min-height", maxHeight + "px");
  }
  
  // Run function on page load
  setEqualHeight();
  
  // Optimize window resize performance using debounce
  let resizeTimeout;
  $(window).resize(function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(setEqualHeight, 100);
  });
});



// Card Label Height Equal
$(document).ready(function () {
  function setMinLabelHeight() {
    var minLabelHeight = 0;

    // Reset label height to auto before calculating
    $(".grid-item h4").css("min-height", "auto");

    // Find the tallest label (min-height logic)
    $(".grid-item h4").each(function () {
      var thisHeight = $(this).outerHeight();
      if (thisHeight > minLabelHeight) {
        minLabelHeight = thisHeight;
      }
    });

    // Set min-height for all labels but do not restrict max-height
    $(".grid-item h4").css("min-height", minLabelHeight + "px");
  }

  // Run function on page load
  setMinLabelHeight();

  // Run again on window resize
  $(window).resize(setMinLabelHeight);
});

// Product card Label Height Equal
$(document).ready(function () {
  function setMinLabelHeight() {
    var minLabelHeight = 0;

    // Reset label height to auto before calculating
    $(".card__heading.h5").css("min-height", "auto");

    // Find the tallest label (min-height logic)
    $(".card__heading.h5").each(function () {
      var thisHeight = $(this).outerHeight();
      if (thisHeight > minLabelHeight) {
        minLabelHeight = thisHeight;
      }
    });

    // Set min-height for all labels but do not restrict max-height
    $(".card__heading.h5").css("min-height", minLabelHeight + "px");
  }

  // Run function on page load
  setMinLabelHeight();

  // Run again on window resize
  $(window).resize(setMinLabelHeight);
});

// Product card Part Number Label Height Equal
$(document).ready(function () {
  function setMinLabelHeight() {
    var minLabelHeight = 0;

    // Reset label height to auto before calculating
    $(".product-skew").css("min-height", "auto");

    // Find the tallest label (min-height logic)
    $(".product-skew").each(function () {
      var thisHeight = $(this).outerHeight();
      if (thisHeight > minLabelHeight) {
        minLabelHeight = thisHeight;
      }
    });

    // Set min-height for all labels but do not restrict max-height
    $(".product-skew").css("min-height", minLabelHeight + "px");
  }

  // Run function on page load
  setMinLabelHeight();

  // Run again on window resize
  $(window).resize(setMinLabelHeight);
});

// Nav-Dropdown
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".has-submenu > .dropdown-arrow").forEach(arrow => {
        arrow.addEventListener("click", function (event) {
            event.stopPropagation();
            let submenu = this.nextElementSibling;
            submenu.style.display = submenu.style.display === "block" ? "none" : "block";
        });
    });
});
// document.querySelectorAll('.menu-item.has-submenu').forEach(item => {
//     item.addEventListener('mouseenter', function () {
//         this.classList.add('open');
//     });
//     item.addEventListener('mouseleave', function () {
//         this.classList.remove('open');
//     });
// });
   // document.addEventListener("DOMContentLoaded", function () {
   //      const megaMenuParent = document.querySelector(".has-submenu");

   //      // Toggle Mega Menu on Click (For Mobile View)
   //      megaMenuParent.addEventListener("click", function (event) {
   //          event.preventDefault();
   //          const megaMenu = this.querySelector(".mega-menu");
   //          const isVisible = megaMenu.style.display === "flex";

   //          // Hide all mega menus first
   //          document.querySelectorAll(".mega-menu").forEach(menu => menu.style.display = "none");

   //          // Toggle the clicked one
   //          megaMenu.style.display = isVisible ? "none" : "flex";
   //      });

   //      // Close on outside click
   //      document.addEventListener("click", function (event) {
   //          if (!megaMenuParent.contains(event.target)) {
   //              document.querySelector(".mega-menu").style.display = "none";
   //          }
   //      });
   //  });
